import { FC, useEffect, useState } from 'react'
import { OptionType } from '../../models/global.model';
import AppEditList from './app-edit-list';
import { deletePriceType, hideAndCreateNewPriceType } from '../../services/priceTypesService';
import { ServiceQuotation } from '../../services/service-quotation';
import styles from './app-edit-price-fields.module.scss';
import { useTranslation } from 'react-i18next';

const AppEditPriceFields : FC = () => {
  const [priceFields, setPriceFields] = useState<OptionType[]>([]);
  const [loading, setLoading] = useState(true);
  const [t] = useTranslation('settings', { keyPrefix: 'editPriceFields'});

  useEffect(() => {
    (async () => {
      let allPriceTypes = await ServiceQuotation.getPriceTypes();
      allPriceTypes = allPriceTypes.map((d: { _id: string, name: string }) => ({ label: d.name, value: d._id }));
      setPriceFields(allPriceTypes);
      setLoading(false);
    })();
  }, []);

  return <div>
    <p className={styles.intro}>
      {t('intro', 'Här kan du ändra eller ta bort de prisfält som föreslås när man skapar förfrågningsunderlag. Förändringar påverkar inte förfrågningsunderlag som redan är skapade.')}
    </p>
    <AppEditList
      listType="priceFields"
      list={priceFields ?? []}
      loading={loading}
      onChangeLabel={async (label, id) => {
        const created = await hideAndCreateNewPriceType(label, id);
        setPriceFields(prev => {
          const index = prev.findIndex(p => p?.value === id);
          const updated = [...prev];
          updated[index] = { label: created.name, value: created._id };
          return updated;
        });
      }}
      onDelete={async (id) => {
        await deletePriceType(id);
        setPriceFields(prev => {
          const index = prev.findIndex(p => p?.value === id);
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        })
      }}
    />
  </div>;
}

export default AppEditPriceFields;
